import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({

  CounterDown: {
    color: '#2b3990',
    fontSize: 14,
    margin: 'auto',
    display: 'block',
    width: '100%',
        border:' 1px solid rgba(43, 57, 144, 0.5)',
width: '60px',
    marginRight: 'auto',
    display: 'inline-block',
    borderRadius: '5px',
    textAlign: 'center',
        height: '30px',
    lineHeight: '30px',
    '&.TimeStop': {
      color: '#9b9b9b',
    },
 
  },

}));